import { render, staticRenderFns } from "./DataAccessSubscriptionPacks.vue?vue&type=template&id=aa581d0e&scoped=true&"
import script from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
export * from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessSubscriptionPacks.vue?vue&type=style&index=0&id=aa581d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa581d0e",
  null
  
)

export default component.exports